import React from "react";
import {
  Drawer,
  Box,
  Typography,
  Divider,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Stack,
} from "@mui/material";
import DocumentItem from "../../Components/Masters/DocumentItem";
import { put } from "../../utils/api";

const ViewDetailsDrawerOnRoad = ({
  open,
  onClose,
  data,
  setsnackOpen,
  fetchDataCallback,
  apiUrl,
}) => {
  if (!data) return null;

  const handleApprovalAction = async (action) => {
    try {
      const response = await put(`${apiUrl}/${data._id}`, {
        approvalStatus: action === "approve" ? "Accepted" : "Rejected",
      });
      if (response?.data) {
        setsnackOpen({
          open: true,
          message: response.data.message,
          severity: "success",
        });
        fetchDataCallback();
        onClose(); // Close drawer after action
      }
    } catch (error) {
      console.error(`${action} error:`, error);
      setsnackOpen({
        open: true,
        message: error.message || "An error occurred",
        severity: "error",
      });
    }
  };

  const formatCalorificValue = (val) =>
    val?.value !== null ? `${val?.value ?? 0} ${val?.unit || ""}` : "—";

  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <Box width="90vw" maxWidth={1000} p={3}>
        <Typography variant="h6" fontWeight="bold" gutterBottom>
          Entry Details
        </Typography>
        <Divider sx={{ mb: 2 }} />

        <TableContainer component={Paper} sx={{ mb: 3 }}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>
                  <strong>Field</strong>
                </TableCell>
                <TableCell>
                  <strong>Previous</strong>
                </TableCell>
                <TableCell>
                  <strong>Requested</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>Consumption Month</TableCell>
                <TableCell>
                  {data?.consumptionPeriod?.month}/
                  {data?.consumptionPeriod?.year}
                </TableCell>
                <TableCell>
                  {data?.editValue?.consumptionPeriod?.month}/
                  {data?.editValue?.consumptionPeriod?.year}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>Transport Type</TableCell>
                <TableCell>{data?.transportType || "—"}</TableCell>
                <TableCell>{data?.editValue?.transportType || "—"}</TableCell>
              </TableRow>

              <TableRow>
                <TableCell>Ownership Type</TableCell>
                <TableCell>{data?.ownershipType || "—"}</TableCell>
                <TableCell>{data?.editValue?.ownershipType || "—"}</TableCell>
              </TableRow>

              <TableRow>
                <TableCell>Vehicle Number</TableCell>
                <TableCell>{data?.vehicleNumber || "—"}</TableCell>
                <TableCell>{data?.editValue?.vehicleNumber || "—"}</TableCell>
              </TableRow>

              <TableRow>
                <TableCell>Fuel Type</TableCell>
                <TableCell>{data?.fuelType || "—"}</TableCell>
                <TableCell>{data?.editValue?.fuelType || "—"}</TableCell>
              </TableRow>

              <TableRow>
                <TableCell>Fuel Consumed</TableCell>
                <TableCell>
                  {data?.fuelConsumed?.value} {data?.fuelConsumed?.unit}
                </TableCell>
                <TableCell>
                  {data?.editValue?.fuelConsumed?.value}{" "}
                  {data?.editValue?.fuelConsumed?.unit}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>Distance Covered</TableCell>
                <TableCell>{data?.distanceCovered || "—"}</TableCell>
                <TableCell>{data?.editValue?.distanceCovered || "—"}</TableCell>
              </TableRow>

              <TableRow>
                <TableCell>Remark</TableCell>
                <TableCell>{data?.remarks || "—"}</TableCell>
                <TableCell>{data?.editValue?.remarks || "—"}</TableCell>
              </TableRow>

              <TableRow>
                <TableCell>Document</TableCell>
                <TableCell>
                  <Box display="flex" flexWrap="wrap" gap={1}>
                    {data?.documents?.length > 0
                      ? data?.documents.map((url, index) => (
                          <DocumentItem key={`doc-${index}`} url={url} />
                        ))
                      : "—"}
                  </Box>
                </TableCell>
                <TableCell>
                  <Box display="flex" flexWrap="wrap" gap={1}>
                    {data?.editValue?.documents?.length > 0
                      ? data?.editValue?.documents.map((url, index) => (
                          <DocumentItem key={`edit-doc-${index}`} url={url} />
                        ))
                      : "—"}
                  </Box>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <Box display="flex" flexDirection="column" gap={1}>
          {Array.isArray(data?.timeLine) && data.timeLine.length > 0 ? (
            (() => {
              // Get the last non-empty array
              const lastEntryArray = [...data.timeLine]
                .reverse()
                .find((arr) => Array.isArray(arr) && arr.length > 0);

              if (!lastEntryArray || lastEntryArray.length === 0) return null;

              const lastEntry = lastEntryArray[lastEntryArray.length - 1];

              const timestamp = new Date(lastEntry.timeStamp);
              const date = timestamp.toLocaleDateString("en-IN");
              const time = timestamp.toLocaleTimeString("en-IN", {
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
              });

              return (
                <Box display="flex" flexDirection="column" gap={1}>
                  <Typography variant="body2">
                    <strong>Created By:</strong> {lastEntry?.name}
                  </Typography>
                  <Typography variant="body2">
                    <strong>Remark Reason:</strong> {data?.editRemarkReason}
                  </Typography>
                  <Typography variant="body2">
                    <strong>Date:</strong> {date}
                  </Typography>
                  <Typography variant="body2">
                    <strong>Time:</strong> {time}
                  </Typography>
                </Box>
              );
            })()
          ) : (
            <Typography variant="body2">
              No timeline history available
            </Typography>
          )}
        </Box>

        {/* Action Buttons */}
        <Stack direction="row" spacing={2} mt={4} justifyContent="flex-end">
          <Button
            variant="contained"
            color="success"
            onClick={() => handleApprovalAction("approve")}
          >
            Approve
          </Button>
          <Button
            variant="outlined"
            color="error"
            onClick={() => handleApprovalAction("reject")}
          >
            Reject
          </Button>
        </Stack>
      </Box>
    </Drawer>
  );
};

export default ViewDetailsDrawerOnRoad;
